import React, { useState, useEffect } from 'react'
import ReactOnRails from 'react-on-rails'
import axios from 'axios'
import isEqual from 'lodash.isequal'
import AnalyticsHelper from 'assets/AnalyticsHelper'
import GenericHelper from 'assets/GenericHelper'
import RouteMap from 'assets/RouteMap.js'
import URLParamsHandler from 'assets/URLParamsHandler.js'
import FiltersHelper from 'assets/FiltersHelper'
import SchoolIndexHelmet from 'helmets/SchoolIndexHelmet'
import SchoolAPI from 'api/SchoolAPI'
import SchoolIndexView from './SchoolIndexView'

const SchoolIndex = (props) => {
    const { user, refreshParamsForUrlTranslation, searchableCityList } = props

    const [schools, setSchools] = useState([])
    const [filters, setFilters] = useState({
        province: [],
        studyDomain: [],
        programType: [],
        title: '',
        page: URLParamsHandler.loadCurrentPage()
    })
    const [loadMoreStatus, setLoadMoreStatus] = useState(true)
    const [schoolCount, setSchoolCount] = useState(0)
    const [loading, setLoading] = useState(true)
    const urlFilters = URLParamsHandler.loadUrlFilters('education')

    useEffect(() => {
        sendIndexViewEvent()
        axios.defaults.headers.common['X-CSRF-TOKEN'] = ReactOnRails.authenticityToken()
    }, [])

    const sendIndexViewEvent = () => {
        AnalyticsHelper.sendGTMEvent(
            'Education list viewed',
            AnalyticsHelper.constructIndexListViewedAnalyticsAttributes(
                user,
                'education'
            )
        )
    }

    const sendFilterEvent = (filters) => {
        AnalyticsHelper.sendGTMEvent(
            'Education Filter Applied',
            AnalyticsHelper.constructEducationFilterAnalyticsAttribute(
                user,
                filters
            )
        )
    }

    const isSearchEmpty = () => {
        if (filters) {
            return (
                !filters.title?.length &&
                !filters.province?.length &&
                !filters.studyDomain?.length &&
                !filters.programType?.length
            )
        }
        return false
    }

    const filterSchools = (tmpFilters) => {
        const newFilters = tmpFilters || filters
        const haveFiltersChanged = !isEqual(tmpFilters, filters)

        setFilters(newFilters)
        setLoading(true)
        if (newFilters.page === 1) setSchools([])

        if (!isSearchEmpty()) sendFilterEvent(filters)

        const data = {
            locale: RouteMap.GetLocaleFromUrl(),
            title: newFilters.title,
            study_domain: FiltersHelper.getValues(newFilters.studyDomain),
            province: newFilters.province,
            program_type: FiltersHelper.getValues(newFilters.programType),
            page: newFilters.page
        }

        SchoolAPI.FilterSchools(data).then((response) => {
            let newSchools = response.data.schools
            if (response.data.page !== '1') {
                newSchools = schools.concat(response.data.schools)
            }

            if (user) {
                const hasFilters = Object.values(filters).some((filter) =>
                    GenericHelper.isPresent(filter)
                )
                if (hasFilters && haveFiltersChanged) {
                    AnalyticsHelper.sendAnalyticsEvent('track', {
                        user_id: user.id,
                        event_name: 'Item Searched',
                        custom_props: {
                            item_type: 'education',
                            filters: data,
                            results_count: response.data.school_count
                        }
                    })
                }
            }

            setLoadMoreStatus(!response.data.is_last_page)
            if (response.data.school_count === 0) setLoadMoreStatus(false)
            setLoading(false)
            setSchools(newSchools)
            setSchoolCount(response.data.school_count)

            window.prerenderReady = true

            URLParamsHandler.createURLFilters('education', newFilters, response.data.page)
            refreshParamsForUrlTranslation()
        })
            .catch((error) => {
                console.error(error)
            })
    }

    const showMoreOnClick = () => {
        filterSchools({ ...filters, page: filters.page + 1 })
    }

    return (
        <>
            <SchoolIndexHelmet/>
            <SchoolIndexView
                searchableCityList={searchableCityList}
                user={user}
                schools={schools}
                schoolCount={schoolCount}
                loading={loading}
                loadMoreStatus={loadMoreStatus}
                showMoreOnClick={showMoreOnClick}
                filterSchools={filterSchools}
                filters={filters}
                setFilters={setFilters}
                urlFilters={urlFilters}
            />
        </>
    )
}

export default SchoolIndex
